module.exports = __webpack_public_path__ + "static/media/vhs.35c8471d.svg";